module.exports = __webpack_public_path__ + "img/property_4_prestige.50d4a0a2.jpg";